export default __webpack_public_path__ + "assets/nl-NL.a63ceb1f06816eb315d1683a4c1591ed.svg";